import axios from 'axios'

export const addUserToKlaviyoList = (email, listId) => {
  if (email && listId) {
    axios
      .get('/.netlify/functions/klaviyo-add-to-list', {
        params: { email, listId },
      })
      .catch((error) => {
        console.error(error, {
          source: 'klaviyo.client.addUserToKlaviyoList',
        })
      })
  }
}

export const addCartToKlaviyoLists = (cart) => {
  try {
    addUserToKlaviyoList(
      cart.email,
      process.env.GATSBY_KLAVIYO_LIST_ID_ALL_PURCHASERS
    )
  } catch (error) {}
}
